// extracted by mini-css-extract-plugin
export default {"three":"SecThree_three__BUnz0","main":"SecThree_main__l-Lw0","up":"SecThree_up__Ufb1S","down":"SecThree_down__YkDb5"};